import type { FC } from "react";

import { DocumentType } from "@/constants/Documents";
import Spinner from "@/ui/core/Spinner";
import { Box } from "@/ui/layout";
import {
  ExcelIcon,
  GenericIcon,
  ImageIcon,
  InvalidDocumentIcon,
  PDFIcon,
  WordIcon,
} from "@/ui/theme/icons/documents";

const DocumentIconSize = 36;

const DocumentExtensionToIconMapper: Record<
  DocumentType,
  FC<DocumentIconSVG>
> = {
  [DocumentType.Excel]: ExcelIcon,
  [DocumentType.Generic]: GenericIcon,
  [DocumentType.Image]: ImageIcon,
  [DocumentType.PDF]: PDFIcon,
  [DocumentType.Word]: WordIcon,
};

interface DocumentIconProps {
  documentType: DocumentType;
  isInvalid?: boolean;
  isLoading?: boolean;
}

const DocumentIcon = ({
  documentType,
  isInvalid,
  isLoading,
}: DocumentIconProps) => {
  if (isInvalid) {
    return <InvalidDocumentIcon size={DocumentIconSize} />;
  }

  if (isLoading) {
    return (
      <Box
        alignItems="center"
        height={DocumentIconSize}
        justifyContent="center"
        width={DocumentIconSize}
      >
        <Spinner size="small" />
      </Box>
    );
  }

  const Icon = DocumentExtensionToIconMapper[documentType];
  return <Icon size={DocumentIconSize} />;
};

export type { DocumentIconProps };
export default DocumentIcon;
